import React from 'react';
import './Bjservice.css'; 
import BJSeries from '../../../imgs/DP-Series.webp';
import KIISeries from '../../../imgs/IBM-R-Series.webp';

function Dpservice() {
  return (
    <div className="bj-container">
      <h2 className="heading"></h2>
      <div className="card-wrapper">
        <div className="card-Bjeservise">
          <img
            src={BJSeries}
            alt="BJ Series"
            className="card-image"
          />
          <p className="card-servis">Dp Series-Two-Platen Large Injection Molding Machine</p>
        </div>
        <div className="card-Bjeservise">
          <img
            src={KIISeries}
            alt="KII Series"
            className="card-image"
          />
          <p className="card-servis">IBM-R Series-  Hybrid Injection Molding Machine</p>
        </div>
      </div>
    </div>
  );
}

export default Dpservice;
